// extracted by mini-css-extract-plugin
export default {"container":"legacyWebInterface_container__GmCJE","iframe":"legacyWebInterface_iframe__7OGlI","loader":"legacyWebInterface_loader__x2oQO","error":"legacyWebInterface_error__Qp4nj"};